/* eslint-disable eslint-comments/disable-enable-pair, max-statements */
import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import SeeAllTile from 'src/components/SeeAllTile';
import Offers from 'src/components/Offers';
import ChosenEmptyListing from 'src/components/EmptyListing/ChosenEmptyListing';
import AgreementMissing from 'src/components/EmptyListing/AgreementMissing';

import { ignoreOffer } from 'src/redux/actions/ignore-offer';
import { toggleOffer } from 'src/redux/actions/toggle-offer';


const OffersListingContainer = () => {
  const accountURL = useSelector(({ configReducer }) => configReducer.accountURL);
  const { offers, hasProfilingAgreement } = useSelector(({ offersReducer }) => ({
    offers: offersReducer.offers,
    hasProfilingAgreement: offersReducer.hasProfilingAgreement
  }));
  const dispatch = useDispatch();

  const toggleFavouriteOffer = useCallback((offerId, isFavourite) => {
    dispatch(toggleOffer({ offerId, isFavourite }));
  }, []);

  const ignoreRecommendedOffer = useCallback((offerId) => {
    dispatch(ignoreOffer({ offerId }));
  }, []);

  if (!hasProfilingAgreement) {
    return <AgreementMissing />;
  }

  if (offers.length === 0) {
    return <ChosenEmptyListing />;
  }

  const renderSeeMoreText = () => {
    const seeMoreTopText = 'Zobacz wszystkie';
    const seeMoreDownText = 'rekomendowane oferty';
    return (
      <Fragment>
        { seeMoreTopText }
        <br />
        { seeMoreDownText }
      </Fragment>
    );
  };

  return (
    <Fragment>
      <Offers
        offers={ offers }
        remove={ ignoreRecommendedOffer }
        toggleFavourite={ toggleFavouriteOffer }
      />
      <SeeAllTile
        link={ accountURL }
        title="Zobacz wszystkie rekomendowane oferty"
      >
        { renderSeeMoreText() }
      </SeeAllTile>
    </Fragment>
  );
};


export default OffersListingContainer;
